module.exports = __webpack_public_path__ + "static/media/flashgbs-2.77874d8d.jpg";